module.exports = __webpack_public_path__ + "static/media/A12.bb030560.png";